module.exports = __webpack_public_path__ + "img/女-食管癌h.208a3ed9.png";